import React, { FC } from 'react';
import { makeStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { styles } from './styles';

const useStyles = makeStyles()(styles as Record<string, any>);

interface AccessTypeModalProps {
  open: boolean;
  handleClose: () => void;
}

const AccessTypeModal: FC<AccessTypeModalProps> = ({ open, handleClose }) => {

  const { classes } = useStyles();

  return (
    <Dialog
      open={open}
    >
      <DialogTitle
        className={classes.dialogTitleWrapper}
      >
        <Typography variant="h6" className={classes.title}>
          Access Type
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        className={classes.closeButton}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <DialogContent className={classes.accessTypeModalContents}>
        <Typography gutterBottom variant="subtitle1">
          Full Access
        </Typography>
        <Typography gutterBottom variant="body2">
          The invited person will have complete access to your Quicken file with full View & Edit permissions.
        </Typography>
        <br />
        <Typography gutterBottom variant="subtitle1">
          Custom Access
        </Typography>
        <Typography gutterBottom variant="body2">
          Choose which entities to share and assign either View-Only or View & Edit permissions.
        </Typography>
      </DialogContent>
      <DialogActions
        className={classes.dialogAction}
      >
        <Button 
          onClick={handleClose}
          variant="outlined"
          size="small"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccessTypeModal;
